import axios from "axios";
import Config from "../../../config";

const v2_actionPromoteAdmin = (chatId, waId) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/admins/${waId}`
});

export default v2_actionPromoteAdmin;
